export default __webpack_public_path__ + "static/media/trainers.09743a53.svg";